
import { defineComponent } from '@vue/runtime-core'

export default defineComponent({
  name: 'IconClose',

  props: {
    size: {
      type: Number,
      default: 12
    },
    color: {
      type: String,
      default: '#d8d8d8'
    }
  }
})
